export const SuggestedFindingDecision_Pending = 'pending';
export const SuggestedFindingDecision_Accepted = 'accepted`';
export const SuggestedFindingDecision_Rejected = 'rejected';
const SuggestedFindingDecisions = [SuggestedFindingDecision_Pending, SuggestedFindingDecision_Accepted, SuggestedFindingDecision_Rejected];
//# sourceMappingURL=types.js.map